import classnames from 'classnames';
import React from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import FormLabel from '../FormLabel/FormLabel';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string | null;
  register: UseFormRegisterReturn;
  className?: string;
  showErrorBorder?: boolean;
}

const Input = ({
  label,
  error,
  register,
  className,
  required,
  showErrorBorder,
  ...inputProps
}: InputProps) => {
  return (
    <div className={classnames(className)}>
      {label ? (
        <FormLabel label={label} required={required} error={error} />
      ) : null}
      <input
        {...register}
        className={classnames('form-control', {
          'border border-danger': showErrorBorder,
        })}
        {...inputProps}
        aria-label={register.name}
      />
    </div>
  );
};

export default Input;
